exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".YFyLd_uMFrDLa4AiWLvIS path {\n  fill: none;\n  stroke: #3D2525;\n  stroke-width: 1.5px;\n  stroke-linejoin: round;\n}\n", ""]);

// exports
exports.locals = {
	"gridRed": "#AE1E08",
	"waveformBlack": "#3D2525",
	"tracing": "YFyLd_uMFrDLa4AiWLvIS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/pages/Annotation/components/FullECGPreview/Waveform/Waveform.css
// module id = 8798
// module chunks = 23